import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'

export const incomesByCategoryItemSchema = z.object({
  // a real category uuid — incomes have no splits, so there is no
  // `'uncategorized'` sentinel like the expenses report carries.
  id: z.string(),
  name: z.string(),
  color: z.string().nullable(),
  icon: z.string().nullable(),
  values: z.array(z.number()),
  total: z.number(),
  monthlyAverage: z.number(),
})

export type IncomesByCategoryItemDto = z.infer<typeof incomesByCategoryItemSchema>

export const incomesByCategoryResponseSchema = z.object({
  baseCurrency: z.nativeEnum(Currency),
  range: z.object({
    from: z.string(),
    to: z.string(),
  }),
  months: z.array(z.string()),
  categories: z.array(incomesByCategoryItemSchema),
  monthlyTotals: z.array(z.number()),
  rangeMonthlyAverage: z.number(),
  skippedIncomeCount: z.number().int().nonnegative(),
})

export type IncomesByCategoryResponseDto = z.infer<typeof incomesByCategoryResponseSchema>
